import { useTranslation } from 'react-i18next';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useTravelRequestDelete } from '../model/TravelRequestQuery';

interface TravelRequestDeleteButtonProps {
  requestId: Id;
}

export function TravelRequestDeleteButton({ requestId }: TravelRequestDeleteButtonProps) {
  const { t } = useTranslation();
  const mutation = useTravelRequestDelete(requestId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '/travel/requests' },
  });

  return (
    <DeleteButton
      size="xs"
      confirmTitle={t('travel.requests.actions.confirmDelete.title')}
      confirmContent={t('travel.requests.actions.confirmDelete.content')}
      {...deleteProps}
    />
  );
}
